import React, { Component } from 'react'
import { IMG } from '../../themes'
import { BUTTON } from './style'
export class Button extends Component {
  render () {
    const {
      name,
      onClick,
      className = '',
      disabled,
      icon,
      classIcon,
      svg,
    } = this.props

    const handleClick = () => {
      if (!disabled) {
        onClick()
      }
    }

    return (
      <BUTTON
        className={className}
        onClick={handleClick}
        disabled={disabled}
      >
        {
          icon &&
            <img
              className={`icon-btn ${classIcon || ''}`}
              src={IMG[icon]}
              alt='icon-btn'
            />
        }
        {
          svg
        }
        {name}
      </BUTTON>
    )
  }
}
